import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { getAccumulatorFill } from 'utils';

import styles from './styles.pcss';
import { AccumulatorProgressProps } from './types';

const cn = classNames.bind(styles);

export const AccumulatorProgress: FC<AccumulatorProgressProps> = ({
  size,
  rest,
  isUnlimited,
  isLow,
}) => {
  const fillPortion = getAccumulatorFill({ size, rest, isUnlimited });

  return (
    <div className={cn('component', { 'component--low': isLow })}>
      <div className={cn('size')} />
      <div className={cn('filled')} style={{ width: `${fillPortion * 100}%` }} />
    </div>
  );
};
